<template>
  <div>
    <v-header ref="header"></v-header>
    <div class="main1">
      <!-- 套餐头部标题和图片  -->
      <div class="mobelphone">
        <div>
          <img class="rb-object-fit w-100 blur-up ls-is-cached lazyloaded" height="160" :src="meal.image"/>
        </div>
      </div>
      <section class="hTitle">
        <div class="container">
          <div class="row">
            <div class="left">
              <div>
                <a class=" font-size-base rb-font-color-classic-bluefont-weight-bold" href="/">主頁</a>
                ／
                <span class="font-size-base">{{ meal.name }}</span>
              </div>
              <div>
                <h1 class="rb-font-size-24 mb-1">{{ meal.name }}</h1>
                <div class="mb-2">
                  <h6 class="font-size-base font-weight-bold"> {{ meal.name }} </h6>

                  <p style="margin: 0.5rem 0" class="font-weight-bold">
                    ${{ meal.price ? meal.price.toFixed(2) : null }}
                  </p>
                </div>
                <h5 class="rb-font-size-16 rb-font-color-dark-grey">
                  14 小時 前預訂
                </h5>

                <div class="d-flex" @click="delivery">
                  <a href="javascript:;" class="font-weight-bold">
                    <img class="rb-object-fit mr-2" height="25" width="25" src="https://cdn.reubird.hk/icon/delivery.svg"/> 運費表
                  </a>
                </div>
              </div>
            </div>
            <div class="right">
              <div>
                <img height="180" :src="meal.image" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 套餐导航  -->
      <section class="navTitle">
        <div class="container py-0">
          <div class="row my-0">
            <div class="left" style="padding-bottom: 0">
              <div>
                <div>
                  <nav class="main-menu" id="menu-scrollnav">
                    <ul class="nav nav-pills x-scroll">
                      <li class="nav-item" v-for="(item, key) in type" :key="key" @click="navChange(key)" >
                        <!-- :href="'#title' + key" -->
                        <a
                          class="nav-link"
                          :class="index === key ? 'active' : null"
                          ><span class="font-size-base font-weight-bold">{{
                            item
                          }}</span></a
                        >
                      </li>
                      <!-- <li class="nav-item">
                        <a class="nav-link"
                          ><span class="font-size-base font-weight-bold"
                            >日式冷盘</span
                          ></a
                        >
                      </li>
                      <li class="nav-item">
                        <a class="nav-link"
                          ><span class="font-size-base font-weight-bold"
                            >烘培包点</span
                          ></a
                        >
                      </li>
                      <li class="nav-item">
                        <a class="nav-link"
                          ><span class="font-size-base font-weight-bold"
                            >小食及拼盘</span
                          ></a
                        >
                      </li>
                      <li class="nav-item">
                        <a class="nav-link"
                          ><span class="font-size-base font-weight-bold"
                            >夏日清凉饮品</span
                          ></a
                        >
                      </li>
                      <li class="nav-item">
                        <a class="nav-link"
                          ><span class="font-size-base font-weight-bold"
                            >主食类</span
                          ></a
                        >
                      </li>
                      <li class="nav-item">
                        <a class="nav-link"
                          ><span class="font-size-base font-weight-bold"
                            >蔬菜类</span
                          ></a
                        >
                      </li>

                      <li class="nav-item">
                        <a class="nav-link"
                          ><span class="font-size-base font-weight-bold"
                            >甜点</span
                          ></a
                        >
                      </li>
                      <li class="nav-item">
                        <a class="nav-link"
                          ><span class="font-size-base font-weight-bold"
                            >追加之选(此美食须额外加购)</span
                          ></a
                        >
                      </li>
                      <li class="nav-item">
                        <a class="nav-link"
                          ><span class="font-size-base font-weight-bold"
                            >小朋友专区</span
                          ></a
                        >
                      </li>
                      <li class="nav-item">
                        <a class="nav-link"
                          ><span class="font-size-base font-weight-bold"
                            >热辣辣惹味煲仔(此美食须额外加购)</span
                          ></a
                        >
                      </li> -->
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 套餐详情 -->
      <section class="dishes">
        <div class="container">
          <div class="row">
            <div class="left">
              <div
                class="products"
                v-for="(item, index) in meal.classify"
                :key="index"
                :id="'title' + index"
              >
                <h5 ref="title" class="protitle">
                  {{ item.name }}
                  <el-tag v-if="item.max"
                    >請從以下選項中選擇總共 {{ item.max }} 份</el-tag
                  >
                </h5>
                <div class="firstBox">
                  <div
                    class="secondBox"
                    v-for="(i, key) in item.dishes"
                    :key="key"
                  >
                    <div class="thirdBox">
                      <div class="fourthBox">
                        <div>
                          <img :src="i.image" />
                          <div>
                            <h5>{{ i.name }}</h5>
                            <div class="calc">
                              <h5>${{ i.price }}</h5>
                              <div>
                                <!-- <button @click="subtract(i, $event)">-</button> -->
                                <button
                                  :class="[item.SBeyond ? 'dis' : null]"
                                  :disabled="item.SBeyond"
                                  @click="subtract(i, i.count)"
                                >
                                  -
                                </button>
                                <div>{{ i.count }}</div>
                                <!-- <button :class="[item.Beyond?'dis':null]"  @click="add(i, $event)" :disabled="item.Beyond">+</button> -->
                                <button
                                  :class="[item.Beyond ? 'dis' : null]"
                                  :disabled="item.Beyond"
                                  @click="add(i, i.count)"
                                >
                                  +
                                </button>
                              </div>
                            </div>
                            <div class="font-size-base">
                              <img
                                src="https://cdn.reubird.hk/general/application/catering/broccoli.svg"
                                height="12"
                              />&nbsp;<span>純素</span>&nbsp;
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="Shipping">
                <h5 ref="delivery">运费</h5>
                <hr class="rs-theme-bg" />
                <div class="shippingflex" v-for="i in 6" :key="i">
                  <div>
                    <h5>
                      送貨 -
                      僅限觀塘市中心（但不包括牛頭角；秀茂坪；藍田；九龍灣）
                    </h5>
                  </div>
                  <div>
                    <h5>+HK$ 30</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="cart">
                <div class="show-at">
                  <img :src="meal.image" height="130" />
                  <h3 class="rb-font-size-16 mb-1">{{ meal.name }}</h3>
                  <div>
                    <h6 class="font-size-base font-weight-bold">
                      {{ meal.name }}
                    </h6>
                    <p style="margin: 0.5rem 0" class="font-weight-bold">
                      ${{ meal.price ? meal.price.toFixed(2) : null }}
                    </p>
                  </div>
                  <h5 class="font-size-base rb-font-color-dark-grey mb-2">
                    14 小時 前預訂
                  </h5>
                  <div class="d-flex" style="cursor: pointer" @click="delivery">
                    <a class="font-weight-bold">
                      <img
                        class="rb-object-fit mr-2"
                        height="20"
                        width="20"
                        src="https://cdn.reubird.hk/icon/delivery.svg"
                      />
                      運費表
                    </a>
                  </div>
                </div>
                <div class="shopping-widget">
                  <button class="btn" @click="showModal">立即订购</button>
                  <div>
                    <h5>
                      <i
                        class="far fa-star rs-theme-color"
                        aria-hidden="true"
                      ></i>
                      <span class="rs-theme-secondary-color"
                        >按此登入，落單時就可以儲積分</span
                      >
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 訂單信息彈出 -->
    <el-dialog
      title="title"
      modal
      :visible.sync="orderModal"
      width="35%"
      custom-class="orderClass"
    >
      <div slot="title">
        <h6 v-if="comName === 'orderContent'">你好，請先確認訂單信息</h6>
        <button
          class="headerBtn"
          v-else-if="comName === 'Methods'"
          @click="Previous('orderContent')"
        >
          <i class="el-icon-arrow-left"></i>
          我的購物車
        </button>
        <button
          class="headerBtn"
          v-else-if="comName === 'orderContact'"
          @click="Previous('orderForm')"
        >
          <i class="el-icon-arrow-left"></i>
          送貨資料
        </button>
        <button
          class="headerBtn"
          v-else-if="comName === 'orderForm'"
          @click="Previous('Methods')"
        >
          <i class="el-icon-arrow-left"></i>
          送貨方法
        </button>
        <button class="headerBtn" v-else @click="Previous('orderContact')">
          <i class="el-icon-arrow-left"></i>
          聯絡資料
        </button>
      </div>
      <div slot="footer" class="orderfooter">
        <div class="orderfooter1" v-if="comName === 'orderContent'">
          <div>
            <p>Total:</p>
            <h5 style="font-size: 1rem; margin: 0">
              ${{
                meal.price
                  ? (meal.price * (meal.count === 0 ? 1 : meal.count)).toFixed(
                      2
                    )
                  : null
              }}
            </h5>
          </div>
          <div>
            <button @click="next('Methods')">
              下一步 : 送貨方式
              <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
        <div class="orderfooter1" v-if="comName === 'orderForm'">
          <div class="contact">
            <button @click="next('orderContact')">
              下一步 : 填寫聯絡資料
              <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
        <div class="orderfooter1" v-if="comName === 'orderContact'">
          <div class="contact">
            <button @click="next('pay')">
              下一步 : 選擇付款方法
              <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
        <div class="orderfooter2">
          <span :class="comName === 'orderContent' ? 'active' : null"
            >選擇菜式</span
          >
          <span>
            <i class="el-icon-arrow-right"></i>
          </span>
          <span :class="comName === 'orderForm' ? 'active' : null">
            送貨資料
          </span>
          <span>
            <i class="el-icon-arrow-right"></i>
          </span>
          <span :class="comName === 'orderContact' ? 'active' : null"
            >聯絡資料
          </span>
          <span>
            <i class="el-icon-arrow-right"></i>
          </span>
          <span :class="comName === 'pay' ? 'active' : null"
            >選擇付款方法並落單</span
          >
        </div>
      </div>
      <component
        :meal="meal"
        :way="way"
        :is="comName"
        :form="form"
        :additional="additional"
        @updateAdditional="updateAdditional"
        @updateCom="next"
        @updateForm="updateForm"
        ref="childRules"
      ></component>
    </el-dialog>
  </div>
</template>
<script>
import "./products.css";
import { getMeal } from "@/gql/meal/query.gql";
import orderContent from "./child/orderContent.vue";
import Methods from "./child/methods.vue";
import orderForm from "./child/form.vue";
import orderContact from "./child/contact.vue";
import pay from "./child/pay.vue";
export default {
  data() {
    return {
      bool: true,
      index: 0,
      type: [],
      meal: [],
      offset: [],
      order: [],
      orderModal: false,
      mobel: 220,
      windowWidth: document.documentElement.clientWidth,
      comName: "orderContent",
      way: undefined,
      additional: {
        tableware: 0,
        tablewarePrice: 3,
        clamp: 0,
        clampPrice: 5,
      },
      form: {
        orderAmount: 0,
        date: "",
        time: "",
        area: "",
        deliveryAddress: "",
        arrdress: "",
        claim: "",
        tableware: "",
        clamp: "",
        name: "",
        email: "",
        phone: "",
        backphone: "",
      },
    };
  },
  mounted() {
    var name = this.$route.query.name;
    this.getQuery(getMeal, { find: { name } }).then((res) => {
      this.meal = res.data.getMeal[0];
      this.$set(this.meal, "count", 1);
      let data = this.meal.classify;
      data.forEach((element) => {
        this.type.push(element.name);
        if (element && element.default && element.default.length > 0) {
          element.dishes.forEach((el) => {
            element.default.forEach((de) => {
              if (de.name === el.name) {
                this.$set(el, "count", 1);
              }
            });
          });
        } else {
          element.dishes.forEach((el) => {
            this.$set(el, "count", 0);
          });
        }
        if (element.max) {
          if (element.default.length >= element.max) {
            this.$set(element, "SBeyond", true);
            this.$set(element, "Beyond", true);
          }
        } else {
          this.$set(element, "Beyond", false);
        }
      });
      this.$set(this.form, "clamp", this.meal.clamp);
      this.$set(this.form, "tableware", this.meal.tableware);
      this.$nextTick(() => {
        let titles = this.$refs.title;
        this.deliveryfee = this.$refs.delivery.offsetTop;
        this.offset = Array.from(titles).map((title) => {
          return title.getBoundingClientRect();
        });
      });
    });

    // 监听整个页面的滚动条
    window.onscroll = () => {
      var t = document.documentElement.scrollTop || document.body.scrollTop;
      var showAt = document.getElementsByClassName("show-at")[0];

      if (showAt) {
        if (t <= 220) {
          showAt.style.display = "none";
        } else {
          showAt.style.display = "block";
        }
      }

      if (!this.bool) {
        this.bool = true;
        return;
      }
      this.offset.forEach((item, i) => {
        if (t > item.y - this.mobel) this.index = i;
      });
    };
    window.addEventListener("resize", () => {
      this.windowWidth = document.documentElement.clientWidth;
      if (this.windowWidth < 565) {
        this.mobel = 270;
      } else {
        this.mobel = 220;
      }
    });
    this.widthLoad();
  },
  computed: {},
  methods: {
    //接受額外餐具和食物夾
    updateAdditional(form) {
      this.additional = Object.assign({}, form);
    },
    // 接收子組件的表單
    updateForm(form) {
      this.form = Object.assign({}, form);
    },
    Previous(value) {
      this.comName = value;
    },
    next(value, way) {
      // console.log(this.meal);
      let result = this.meal.classify.map((item) => {
        return item.dishes.every((el) => {
          return el.count !== 0;
        });
      });
      // console.log(result)
      if (
        value === "Methods" ||
        value === "orderForm" ||
        value === "orderContent"
      ) {
        if (value === "orderForm") {
          this.$set(this.form, "area", "");
          this.$set(this.form, "deliveryAddress", "");
          this.$set(this.form, "arrdress", "");
        }
        this.comName = value;
        if (way) {
          this.way = way;
        }
      } else {
        if (this.$refs["childRules"].validateForm) {
          let flag = this.$refs["childRules"].validateForm();
          if (flag) {
            this.comName = value;
          } else {
            this.$message.error("保全信息不完整，请继续填写完整");
          }
        }
      }
    },
    showModal() {
      this.orderModal = true;
    },
    subtract(i, count) {
      count--;
      if (count < 0) {
        count = 0;
        this.$set(i, "count", 0);
      } else {
        this.$set(i, "count", count);
      }
      let arr = this.meal.classify;
      arr.forEach((item) => {
        if (i.type === item.name) {
          let total = 0;
          item.dishes.forEach((el) => {
            total += el.count;
          });
          // console.log(total);
          // console.log(item.max);
          if (total >= item.max) {
            // console.log("超過最大值");
            this.$set(item, "Beyond", true);
          } else {
            this.$set(item, "Beyond", false);
          }
        }
      });
    },
    // subtract(i, e) {
    //   let sub = e.target.nextElementSibling.innerText;
    //   sub--;
    //   let arr = this.meal.classify;
    //   arr.forEach((item) => {
    //     this.$set(item, "Beyond", false);
    //     if (i.type === item.name) {
    //       item.dishes.forEach((el) => {
    //         if (i.name === el.name) {
    //           if (sub < 0) {
    //             e.target.nextElementSibling.innerText = 0;
    //             this.$set(el, "count", 0);
    //           } else {
    //             e.target.nextElementSibling.innerText = sub;
    //             this.$set(el, "count", sub);
    //           }
    //         }
    //       });
    //     }
    //   });
    //   if (sub < 0) {
    //     e.target.nextElementSibling.innerText = 0;
    //   } else {
    //     e.target.nextElementSibling.innerText = sub;
    //   }
    // },
    // add(i, e) {
    //   let add = e.target.previousElementSibling.innerText;
    //   add++;
    //   let arr = this.meal.classify;
    //   arr.forEach((item) => {
    //     console.log(item)
    //     if (i.type === item.name) {
    //       let total = 0;
    //       item.dishes.forEach((el) => {
    //         if (i.name === el.name) {
    //           this.$set(el, "count", add);
    //         }
    //         total += el.count;
    //       });
    //       if (total > item.max) {
    //         this.$set(item,"Beyond",true)
    //       }
    //     }
    //   });
    //   e.target.previousElementSibling.innerText = add;
    // },
    add(i, count) {
      count++;
      this.$set(i, "count", count);
      let arr = this.meal.classify;
      arr.forEach((item) => {
        if (i.type === item.name) {
          let total = 0;
          item.dishes.forEach((el) => {
            total += el.count;
          });

          if (total >= item.max) {
            // console.log("超過最大值");
            this.$set(item, "Beyond", true);
          } else {
            this.$set(item, "Beyond", false);
          }
        }
      });
    },
    navChange(key) {
      this.bool = false;
      this.index = key;
      var el = document.documentElement || document.body;
      if (this.offset.length > 0) {
        el.scrollTop = this.offset[key].y - this.mobel;
      }
    },
    delivery() {
      var el = document.documentElement || document.body;
      el.scrollTop = this.deliveryfee - this.mobel;
    },
    // 页面加载后获取窗口大小
    widthLoad() {
      this.$nextTick(() => {
        this.windowWidth = document.documentElement.clientWidth;
      });
    },
  },
  watch: {},
  components: {
    "v-header": () => import("@/components/header.vue"),
    orderContent: orderContent,
    Methods: Methods,
    orderForm: orderForm,
    orderContact: orderContact,
    pay: pay,
  },
};
</script>
<style scoped>
.dis {
  background: #cecece;
  cursor: default;
  border: 0;
}
</style>

